import { render } from "./mobile-editor.vue?vue&type=template&id=3d648101&scoped=true"
import script from "./mobile-editor.vue?vue&type=script&lang=js"
export * from "./mobile-editor.vue?vue&type=script&lang=js"

import "./mobile-editor.vue?vue&type=style&index=0&id=3d648101&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d648101"]])

export default __exports__